import Vue from 'vue';
import Vuex, { ModuleTree, Store } from 'vuex';
import { DefineMutations, Dispatcher } from 'vuex-type-helper';
import discounts, { ModuleActions as DiscountsActions } from './modules/discounts';
import newsletter from './modules/newsletter';
import officeSchedule from './modules/officeSchedule';
import orm from './modules/orm';
import trustpilot from './modules/trustpilot';
import ui from './modules/ui';
import youTube from './modules/youTube';

export interface Gender {
    value: number;

    display: string;
}

export interface RootState {
    debug: boolean;
}

export interface RootActions {
    loadState;
}

declare const process: {
    env: {
        NODE_ENV: string,
    },
};

Vue.use(Vuex);

const modules: ModuleTree<RootState> = {
    discounts,
    newsletter,
    officeSchedule,
    orm,
    trustpilot,
    ui,
    youTube,
};

const debug: boolean = process.env.NODE_ENV !== 'production';

// const actions: DefineActions<RootActions, RootState, {}> = {
//     loadState(s: ActionContext<RootState, RootState>) {
//         const { airports = [], destinations = [], combinations = [], tours = [], flights = [] } = africaState;
//         s.commit('orm/populateAirports', airports);
//         s.commit('orm/populateCombinations', combinations);
//         s.commit('orm/populateDestinations', destinations);
//         s.commit('orm/populateFlights', flights);
//         s.commit('orm/populateTours', tours);
//     },
// };

const mutations: DefineMutations<{}, RootState> = {};

const state: RootState = {
    debug,
};

const store: Store<RootState> = new Vuex.Store({
    state,
    // actions,
    mutations,
    modules,
    strict: debug,
});

// store.dispatch<Dispatcher<RootActions>>({
//     type: 'loadState',
// });

// store.dispatch<Dispatcher<RootActions>>({
//     type: 'orm/loadDestinations',
// });

store.dispatch<Dispatcher<DiscountsActions>>({
    type: 'discounts/fetchDiscounts',
});

// store.dispatch<Dispatcher<RootActions>({
//     type: 'officeSchedule/load'
// });

export default store;
